// @flow
import * as React from 'react'
import type { ContentBlocksType } from '../../../services/contentfulMarketingLandingPages'
import HorizontalImageAndText from './HorizontalImageAndText'
import CenteredTextAndImage from './CenteredTextAndImage'
import SpotlightSection from './SpotlightSection'
import UniverseSection from './UniverseSection'
import LongTextSection from './LongTextSection'

export default function ContentBlocks (props: {
  contentBlocks: ContentBlocksType[],
  isFooterVisible: boolean,
  hasBanner: boolean
}): React.Node {
  const isSingleContentBlock = props.contentBlocks.length === 1
  return props.contentBlocks.map((block: any, index: number): React.Node => {
    const isFirst = index === 0
    if (block.type === 'contentBlockHorizontalImageAndText') {
      return (
        <HorizontalImageAndText
          key={block.id}
          block={block}
          isFirst={isFirst}
          isSingleContentBlock={isSingleContentBlock && !props.isFooterVisible}
        />
      )
    } else if (block.type === 'contentBlockCenteredTextAndImage') {
      return (
        <CenteredTextAndImage
          key={block.id}
          block={block}
          isFirst={isFirst}
          isSingleContentBlock={isSingleContentBlock && !props.isFooterVisible}
        />
      )
    } else if (block.type === 'contentBlockSpotlightSection') {
      return (
        <SpotlightSection
          key={block.id}
          block={block}
          isFirst={isFirst}
          isSingleContentBlock={isSingleContentBlock && !props.isFooterVisible}
        />
      )
    } else if (block.type === 'contentBlockUniverseSection') {
      return (
        <UniverseSection
          key={block.id}
          block={block}
          isFirst={isFirst}
          isSingleContentBlock={isSingleContentBlock && !props.isFooterVisible}
        />
      )
    } else if (block.type === 'contentBlockLongText') {
      return (
        <LongTextSection
          key={block.id}
          block={block}
          isFirst={isFirst}
          isSingleContentBlock={isSingleContentBlock && !props.isFooterVisible}
          isBannerSpaceVisible={props.hasBanner && isSingleContentBlock && !props.isFooterVisible}
        />
      )
    } else {
      return null
    }
  })
}
